import apiClient from '../config/api';

export interface ExportJobStatus {
  jobId: string;
  status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  downloadUrl?: string;
  expiresAt?: string;
  error?: string;
  createdAt: string;
  completedAt?: string;
}

export interface CreateExportParams {
  hospitalUuid?: string;
  dateFrom: string;
  dateTill: string;
  format: 'CSV' | 'EXCEL';
  includeFields?: string[];
}

export async function createExportJob(params: CreateExportParams): Promise<{ jobId: string }> {
  const response = await apiClient.post('/api/export/calculations', params);
  return response.data;
}

export async function getExportJobStatus(jobId: string): Promise<ExportJobStatus> {
  const response = await apiClient.get(`/api/export/${encodeURIComponent(jobId)}/status`);
  return response.data;
}

export function getExportDownloadUrl(jobId: string): string {
  const baseUrl = apiClient.defaults.baseURL || 'http://localhost:3001';
  return `${baseUrl}/api/export/${encodeURIComponent(jobId)}/download`;
}
